import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";
import { Animation } from "@nocios/presentation-kit";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import { useEffect, useRef, useState } from "react";
import React from "react";

const PageId = 11;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_1 = `${baseImageUrl}animation_1.png`;
  const rightSideImage_2 = `${baseImageUrl}animation_2.png`;
  const rightSideImage_3 = `${baseImageUrl}animation_3.png`;
  const rightSideImage_4 = `${baseImageUrl}animation_4.png`;
  const rightSideImage_5 = `${baseImageUrl}animation_5.png`;

  const [step, setStep] = useState(0);

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  const rightSideComponentBaseStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    bottom: 0,
    transition: "all 1s ease-in-out",
    width: "var(--width-1920)",
    height: "var(--height-1080)",
  };

  useEffect(() => {
    let timeoutId: any;
    if (currentPage === PageId) {
      if (step === 0) timeoutId = setTimeout(() => setStep(step + 1), 200);
    } else setStep(0);

    return () => {
      setStep(0);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const stepsTime = [200, 1000, 1000, 1000, 1000, 1000, 1000];

  useEffect(() => {
    let timeoutId: any;
    if (step > 0 && step <= stepsTime.length) timeoutId = setTimeout(() => setStep(step + 1), stepsTime[step - 1]);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      if (currentPage === PageId && step === 1) {
        videoRef.current.play();
      } else {
        if (currentPage !== PageId) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
      }
    }
  }, [currentPage, step, videoRef.current]);

  return {
    styleBody: {
      marginTop: "var(--height-50)",
    },
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    gradient: `linear-gradient(268deg, rgba(10, 45, 101, 0) 28.65%, rgb(0, 0, 0) 97.16%) center center / contain no-repeat, linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgb(0 0 0 / 0%) 100%)`,
    title: "Prioritize what’s Important,\nWithout Interruptions",
    description: `Not all internet traffic is created equal. The\nPriority Traffic feature ensures that essential\napplications like work meetings and online\nclasses always get top bandwidth priority over\nless critical activities.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`Key Features:<ul><li style="margin-top:var(--height-10)">Traffic Prioritization: Automatically allocates\nbandwidth to productivity apps like Teams or\nZoom or prioritize your down-time with the best\nperformance for gaming or TV.</li><li style="margin-top:var(--height-10)">Adaptive Network Optimization: AI dynamically\nadjusts traffic based on real-time usage to prevent\nlag and buffering.</li><li style="margin-top:var(--height-10)">User-Controlled Settings: Allow customers to\ncustomize priority levels based on their\nhousehold’s needs.</li></ul>\n`}
      />
    ),
    rightSideComponent: (
      <>
        <video
          ref={videoRef}
          autoPlay={false}
          style={{
            position: "absolute",
            borderRadius: "var(--width-80)",
            right: "var(--width-130)",
            top: "var(--height-130)",
            width: "var(--width-430)",
            zIndex: 100,
          }}
          src={`${Config.BASE_URL}/images/screen_11/video.mp4`}
          controls={false}
        ></video>
        <img
          src={rightSideImage_2}
          alt=""
          style={{
            ...rightSideComponentBaseStyle,
            opacity: step >= 3 ? 1 : 0,
            transform: `scale(${step >= 3 ? 1 : 0.1}) translateY(${step >= 3 ? 0 : "var(--width-600)"})`,
          }}
        />
        <img
          src={rightSideImage_3}
          alt=""
          style={{
            ...rightSideComponentBaseStyle,
            opacity: step >= 4 ? 1 : 0,
            transform: `scale(${step >= 4 ? "1" : "0.3"}) translateX(${step >= 4 ? 0 : "var(--width-800)"})`,
          }}
        />
        <img
          src={rightSideImage_4}
          alt=""
          style={{
            ...rightSideComponentBaseStyle,
            opacity: step >= 5 ? 1 : 0,
            transform: `scale(${step >= 5 ? "1" : "0.3"}) translate(${step >= 5 ? 0 : "calc(-1 * var(--width-800)), var(--height-400)"})`,
          }}
        />
        <img
          src={rightSideImage_5}
          alt=""
          style={{
            ...rightSideComponentBaseStyle,
            opacity: step >= 6 ? 1 : 0,
            transform: `scale(${step >= 6 ? "1" : "0.3"}) translate(${step >= 6 ? 0 : "calc(-1 * var(--width-400)), var(--height-700)"})`,
          }}
        />
      </>
    ),

    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
